function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-745.000000, -1843.000000)",
  stroke: "#183E6B",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(120.000000, 245.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 1545.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(626.000000, 30.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 40,
  x2: 40,
  y2: 0
}), /*#__PURE__*/React.createElement("polyline", {
  strokeLinecap: "square",
  points: "20 0 40 0 40 20"
})))))));
var SvgIconArrowDiagonal = function SvgIconArrowDiagonal(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconArrowDiagonal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-arrow-diagonal.55dbc86c.svg";
export { ForwardRef as ReactComponent };